import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import SOWDocument from "./SOWDocument";
import "../Table/Table.css";
import MSADocument from "./MSADocument";

function NttDocument() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div style={profileStyle}>
      <Box sx={{  marginBottom: "20px" }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="NTT Document Tabs"
          sx={{
            "& .MuiTabs-indicator": { backgroundColor: "rgb(124, 46, 160)" },
            "& .MuiTab-root": {
              color: "rgb(124, 46, 160)",
              textTransform: "none",
              fontWeight: 500,
            },
            "& .MuiTab-root.Mui-selected": {
              color: "rgb(124, 46, 160) !important",
              fontWeight: "bold",
            },
          }}
        >
          <Tab label="MSA" />
          <Tab label="SOW" />
        </Tabs>
      </Box>

      {/* Tab Panels */}
      <Box role="tabpanel" hidden={activeTab !== 0}>
        {activeTab === 0 && <MSADocument />}
      </Box>

      <Box role="tabpanel" hidden={activeTab !== 1}>
        {activeTab === 1 && <SOWDocument />}
      </Box>
    </div>
  );
}

const profileStyle = {
  width: "90%",
  background: "#fff",
  borderRadius: "8px",
  marginInline: "auto",
  marginTop: "20px",
  padding: "20px",
};

export default NttDocument;